import { createContext, use } from "react";
import { defined } from "@entrilia/shared/utilities/typeHelper";
import type { NotesEntityType } from "../../api/types/notesTypes";

export interface ContextValue {
  entityId: string;
  entityType: NotesEntityType;
  objectType?: string;
  hasPermissionsToManageNotes: boolean;
}

export const NotesContext = createContext<ContextValue | undefined>(undefined);

export const useNotesContext = () =>
  defined(use(NotesContext), "Attempted to use NotesContext outside of its provider");
